<template>
  <div :class="divWidthChange" class="conteudoWidth fccPermissoes">
    <fccTitlePage :titlePage="titlePage" />

    <div class="buttonsOptions">
      <button
        v-b-tooltip.hover
        title="Voltar"
        @click="$router.push({ path: '/seguranca/aplicacoes' })"
        class="btn btn-light border shadow-sm ml-2 text-dark"
      >
        <font-awesome-icon icon="chevron-left" />
      </button>
    </div>

    <b-nav class="navPermissoes">
      <b-nav-item :active="pagina === 'grupos'" @click="pagina = 'grupos'">Grupos</b-nav-item>
      <b-nav-item :active="pagina === 'usuarios'" @click="pagina = 'usuarios'">Usuários</b-nav-item>
    </b-nav>

    <fccTable
      key="grupos"
      striped
      hover
      v-if="pagina === 'grupos'"
      :fields="fieldsGrupo"
      responsive
      :porPage="itemPorPage"
      search
      pagination
      :titlePage="titlePage"
      :titlePDF="titlePDF"
      :actions="actionsGrupo"
      :items="listarGrupo"
      pdf
      csv
      xls
    />

    <fccTable
      key="usuarios"
      striped
      hover
      v-if="pagina === 'usuarios'"
      :fields="fields"
      :status="status"
      responsive
      :porPage="itemPorPage"
      search
      pagination
      :titlePage="titlePage"
      :titlePDF="titlePDF"
      :actions="actions"
      :items="listarUsuarios"
      pdf
      csv
      xls
    />

    <fccModal
      centered
      idModal="editPermissao"
      size="xl"
      :titleModal="titleModal"
      escondeFooter
      travaEsc
      travaBack
    >
      <Tree :value="lstObjetos" class="divSearch" @drop="dragMenu()">
        <div
          slot-scope="{ node, path, tree }"
          class="treeCustom"
          :class="{ inactive: node.objpermissoes.length === 0 }"
        >
          <div v-if="node">
            <span
              @click="tree.toggleFold(node, path), openFold(node)"
              v-if="node"
              class="folderTree"
            >
              <font-awesome-icon icon="folder" size="sm" v-if="node.$folded" />
              <font-awesome-icon icon="folder-open" size="sm" v-if="!node.$folded" />
            </span>

            <b-form-checkbox
              @change="mudaGrupo(node.objpermissoes, $event)"
              v-model="permiteGrupo[node.item.objid]"
            >
              {{ node.text }}
            </b-form-checkbox>
          </div>

          <span v-if="!node.$folded">
            <div class="checkPermission" v-if="node.objpermissoes.length > 0">
              <span v-for="item in node.objpermissoes" :key="item.objpermid">
                <b-form-checkbox
                  @change="mudaOk(item.objpermid, $event)"
                  v-model="lstSelecionado[item.objpermid]"
                >
                  {{ item.objpermdescricao }}
                </b-form-checkbox>
              </span>
            </div>
          </span>
        </div>
      </Tree>
    </fccModal>
  </div>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import 'he-tree-vue/dist/he-tree-vue.css'
import { Tree, Fold } from 'he-tree-vue'
import './assets/fccPermissoes.scss'

export default {
  data() {
    return {
      pagina: 'grupos',
      texto: '',
      searchList: '',
      sortBy: 'ordem',
      titlePage: 'Aplicações',
      titleModal: '',
      titlePDF: 'Aplicações',
      listaGrupos: [],
      listaObjetos: [],
      listaGrupo: [],
      objetoFinal: [],
      openGrupo: {},
      selecionaTodos: false,
      todasPermissoes: [],
      permiteGrupo: {},
      lstPermissoes: [],
      selecionado: {},
      seleciona: '',
      objRetorno: {},
      idPermissao: '',
      usuIdPermissao: '',
      listaPermissaoGrupo: [],
      listaUsuarios: [],
      itemPorPage: '100',
      idAplicacao: '',
      status: [
        {
          funcaoButton: 'changeStatus',
          tooltip: 'Alterar Status',
          campoStatus: 'usuativo',
          objpermCodigo: store.state.permissaoMenu.adicionar
        }
      ],
      fields: [
        { key: 'usuid', label: 'Login', sortable: true },
        {
          key: 'usuariocomplemento.usucompnome',
          label: 'Nome',
          sortable: true,
          type: 'sub',
          sub: { sub1: 'usuariocomplemento', sub2: 'usucompnome' }
        },
        {
          key: 'usuariocomplemento.usucompsgsetor',
          label: 'Departamento',
          sortable: true,
          type: 'sub',
          sub: { sub1: 'usuariocomplemento', sub2: 'usucompsgsetor' }
        },
        { key: 'actions', label: '', tdClass: 'no-print', thClass: 'no-print' }
      ],
      actions: [
        {
          button: true,
          funcaoButton: 'editUsuPermissao',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        }
      ],
      statusGrupo: [
        {
          funcaoButton: 'changeGrupo',
          tooltip: 'Alterar Status',
          campoStatus: 'perativo',
          objpermCodigo: store.state.permissaoMenu.editar
        }
      ],
      fieldsGrupo: [
        { key: 'perid', label: 'ID', sortable: true },
        { key: 'pernome', label: 'Nome', sortable: true },
        { key: 'actions', label: '', tdClass: 'no-print', thClass: 'no-print' }
      ],
      actionsGrupo: [
        {
          button: true,
          funcaoButton: 'editPermissao',
          icon: 'edit',
          tooltip: 'Editar',
          objpermCodigo: store.state.permissaoMenu.editar
        }
      ]
    }
  },
  components: { Tree: Tree.mixPlugins([Fold]) },
  methods: {
    openFold(node) {
      this.openGrupo[node.item.objid] = node.$folded
    },
    mudaTodos: async function () {
      for (var itemGrupo of this.todasPermissoes) {
        await this.mudaAsync(itemGrupo, false)
      }
    },
    mudaGrupo(todasPermissoes, event) {
      for (var itemGrupo of todasPermissoes) {
        this.mudaOk(itemGrupo.objpermid, event, true)
      }
    },
    mudaOk: function (item, event, loading = false) {
      var objItem = {}
      if (this.idPermissao) {
        objItem = {
          objusuid: 0,
          perid: this.idPermissao,
          objpermid: item,
          objusuativo: event
        }
      } else {
        objItem = {
          objusuid: 0,
          usuid: this.usuIdPermissao,
          objpermid: item,
          objusuativo: event
        }
      }
      let promisse
      if (this.lstObjetoRetorno[item] !== undefined) {
        objItem.objusuid = this.lstObjetoRetorno[item].objusuid
        promisse = axios.put(
          this.$fccStore.state.baseUrlSeguranca + 'Objeto/alterarobjusupermissao',
          objItem,
          this.dadosLoginSession.fccTokenHeaders
        )
      } else {
        promisse = axios.post(
          this.$fccStore.state.baseUrlSeguranca + 'Objeto/adicionarobjusupermissao',
          objItem,
          this.dadosLoginSession.fccTokenHeaders
        )
      }
      promisse
        .then(() => {
          if (this.idPermissao) {
            this.listandoPermissaoPorGrupo(this.idPermissao, loading)
          } else {
            this.listandoPermissaoPorUsuario(this.usuIdPermissao, loading)
          }
          this.callToast(this.mensagensUpdate.editado, 'success')
        })
        .catch(this.setErrorSystem)
    },
    editPermissao: function (_, item) {
      this.usuIdPermissao = ''
      this.selecionado = {}
      this.objRetorno = {}
      this.todasPermissoes = []
      this.openGrupo = {}
      this.listaPermissaoGrupo = []
      this.permiteGrupo = {}
      this.idPermissao = item.perid
      this.listandoPermissaoPorGrupo(item.perid, true)
      this.titleModal = 'Permissão ' + item.pernome
      this.$root.$emit('bv::show::modal', 'editPermissao')
    },
    editUsuPermissao: function (_, item) {
      this.idPermissao = ''
      this.todasPermissoes = []
      this.selecionado = {}
      this.openGrupo = {}
      this.objRetorno = {}
      this.permiteGrupo = {}
      this.usuIdPermissao = item.usuid
      this.listaPermissaoGrupo = []
      this.listandoPermissaoPorUsuario(item.usuid, true)
      this.titleModal = 'Permissão ' + item.usuariocomplemento.usucompnome
      this.$root.$emit('bv::show::modal', 'editPermissao')
    },
    listandoUsuarios: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.$fccStore.state.baseUrlSeguranca + 'Cadastro/listartodoslogin',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listaUsuarios = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    listandoPermissaoPorUsuario: function (usuid, carregando = false) {
      if (carregando === true) {
        this.carregaTexto(this.codeMensagem('C01'))
      }
      axios
        .get(
          this.$fccStore.state.baseUrlSeguranca +
            'Objeto/listarObjUsuPermissaoPorUsuario?usuID=' +
            usuid,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listaPermissaoGrupo = response.data
          if (this.listaPermissaoGrupo.length > 0) {
            for (var idGrupo of Object.values(this.listaPermissaoGrupo)) {
              this.selecionado[idGrupo.objpermid] = idGrupo.objusuativo
              this.objRetorno[idGrupo.objpermid] = idGrupo
            }
          }
          this.listandoObjetos(1)
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    listandoPermissaoPorGrupo: function (perid, carregando = false) {
      if (carregando === true) {
        this.carregaTexto(this.codeMensagem('C01'))
      }
      axios
        .get(
          this.$fccStore.state.baseUrlSeguranca + 'Objeto/listarObjUsuPermissaoPorGrupo' + perid,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listaPermissaoGrupo = response.data
          if (this.listaPermissaoGrupo.length > 0) {
            for (var idGrupo of Object.values(this.listaPermissaoGrupo)) {
              this.selecionado[idGrupo.objpermid] = idGrupo.objusuativo
              this.objRetorno[idGrupo.objpermid] = idGrupo
            }
          }
          this.listandoObjetos(1)
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    listandoGrupos: function () {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          this.$fccStore.state.baseUrlSeguranca + 'Perfil/listarperfil',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listaGrupos = response.data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    listandoObjetos: function (number = null) {
      if (number === null) {
        this.carregaTexto(this.codeMensagem('C01'))
      }
      axios
        .get(
          this.$fccStore.state.baseUrlSeguranca + 'Menu/listarmenuapp/' + this.idAplicacao,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.listaObjetos = response.data
          this.objetoFinal = []
          this.retornoObjetos(this.listaObjetos, number)
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    listandoApp: function () {
      axios
        .get(
          this.$fccStore.state.baseUrlSeguranca + 'App/listarapp/' + this.idAplicacao,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.titlePage = 'Permissão: ' + response.data.appnome
        })
        .catch((error) => {
          this.carregaTexto()
          this.setErrorSystem(error)
        })
    },
    retornoObjetos: function (lista, number = null) {
      for (var [key, listando] of Object.entries(lista)) {
        this.openGrupo[listando.objid] =
          this.openGrupo[listando.objid] === undefined ? true : this.openGrupo[listando.objid]
        var lstCria = {
          text: listando.objnome,
          objpermissoes: listando.objpermissoes,
          objparent: 0,
          ordem: key,
          objativo: listando.objativo,
          item: listando,
          $folded: this.openGrupo[listando.objid],
          children: []
        }
        this.permiteGrupo[listando.objid] = true
        if (listando.objpermissoes.length > 0) {
          for (var idGrupo of Object.values(listando.objpermissoes)) {
            if (
              this.selecionado[idGrupo.objpermid] === undefined ||
              this.selecionado[idGrupo.objpermid] === false
            ) {
              this.permiteGrupo[listando.objid] = false
            }
            this.todasPermissoes.push(idGrupo.objpermid)
          }
        }
        if (listando.objparent.length > 0) {
          for (var [keyNumber, lstParents] of Object.entries(listando.objparent)) {
            var lstChildren = this.capturaFilho(lstParents, lstCria, keyNumber, number)
            lstCria.children.push(lstChildren)
          }
        }
        this.objetoFinal.push(lstCria)
      }
      this.carregaTexto()
    },
    capturaFilho: function (lista, lstTotal, key) {
      this.openGrupo[lista.objid] =
        this.openGrupo[lista.objid] === undefined ? true : this.openGrupo[lista.objid]
      var lstCria = {
        text: lista.objnome,
        objativo: lista.objativo,
        objparent: lstTotal.item.objid,
        objpermissoes: lista.objpermissoes,
        ordem: key,
        $folded: this.openGrupo[lista.objid],
        item: lista,
        children: []
      }
      this.permiteGrupo[lista.objid] =
        this.permiteGrupo[lista.objid] === undefined ? true : this.permiteGrupo[lista.objid]
      if (lista.objpermissoes.length > 0) {
        for (var idGrupo of Object.values(lista.objpermissoes)) {
          if (
            this.selecionado[idGrupo.objpermid] === undefined ||
            this.selecionado[idGrupo.objpermid] === false
          ) {
            this.permiteGrupo[lista.objid] = false
          }
          this.todasPermissoes.push(idGrupo.objpermid)
        }
      }
      if (lista.objparent !== undefined && lista.objparent !== null) {
        if (lista.objparent.length > 0) {
          for (var [keyNumber, lstParents] of Object.entries(lista.objparent)) {
            var lstChildren = this.capturaFilho(lstParents, lstCria, keyNumber)
            lstCria.children.push(lstChildren)
          }
        }
      }
      return lstCria
    }
  },
  computed: {
    lstPermissaoGrupo() {
      return this.listaPermissaoGrupo
    },
    lstSelecionado() {
      return this.selecionado
    },
    lstObjetos() {
      return this.objetoFinal
    },
    lstObjetoRetorno() {
      return this.objRetorno
    },
    listarGrupo() {
      return this.listaGrupos
    },
    listarUsuarios() {
      return this.listaUsuarios
    }
  },
  mounted: function () {
    this.idAplicacao = this.$route.params.id
    this.listandoApp()
    this.listandoGrupos()
    this.listandoUsuarios()
  }
}
</script>
